import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import styles from './RowAction.module.css';

/**
 * Ação compacta de linha: ícone com tooltip, no mesmo desenho do IconAction do Início
 * (src/pages/dashboard/components/shared), com o tom "danger" para excluir.
 */
function RowAction({ title, onClick, tone = 'neutral', children }) {
    return (
        <Tooltip title={title} arrow>
            <button
                type="button"
                className={`${styles.button} ${styles[tone] || ''}`}
                onClick={onClick}
                aria-label={title}
            >
                {children}
            </button>
        </Tooltip>
    );
}

export default RowAction;
